import { LOCAL_STORAGE } from '@constants';

export default function setAndroidReferrer(key, value) {
  const androidReferrer = new URLSearchParams(
    localStorage.getItem(LOCAL_STORAGE.ANDROID_REFERRER) ?? '',
  );
  androidReferrer.set(key, value);
  localStorage.setItem(LOCAL_STORAGE.ANDROID_REFERRER, androidReferrer.toString());
}
